import { Box } from "@mui/material";
import React from "react";

const CommonEventIcon = ({
    background
}) => {
    return (
        <Box
            sx={{
                width: 13,
                height: 13,
                borderRadius: '50%',
                backgroundColor: background
            }}
        />
    )
}

export default CommonEventIcon;